export class WidgetTypeError extends Error {
  constructor() {
    super("WidgetTypeError: Unknown Widget Type");
  }
}
